import React, { FC, ReactNode, MouseEvent } from 'react';
import classnames from 'classnames';

// @ts-ignore
import styles from './FilterTag.scss';

type FilterTagProps = {
  isActive: boolean;
  onClick: (e: MouseEvent<HTMLDivElement>) => void;
  className?: string;
  children: ReactNode;
};

export const FilterTag: FC<FilterTagProps> = ({ isActive, onClick, className, children }) => {
  const activeStyles = isActive ? styles.active : '';

  return (
    <div onClick={onClick} className={classnames(styles.filterTag, activeStyles, className)}>
      {children}
    </div>
  );
};
